/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $EmployeeDocumentResponse = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        employee_id: {
    type: 'number',
    isRequired: true,
},
        firstName: {
    type: 'string',
    isRequired: true,
},
        lastName: {
    type: 'string',
    isRequired: true,
},
        department_document_id: {
    type: 'number',
    isRequired: true,
},
        department_id: {
    type: 'number',
    isRequired: true,
},
        department_name: {
    type: 'string',
    isRequired: true,
},
        document_id: {
    type: 'number',
    isRequired: true,
},
        document_name: {
    type: 'string',
    isRequired: true,
},
        expiration_date: {
    type: 'string',
    isRequired: true,
    format: 'date',
},
        license: {
    type: 'string',
    isRequired: true,
},
        approval: {
    type: 'string',
    isRequired: true,
},
        document_path: {
    type: 'string',
    isRequired: true,
},
        status: {
    type: 'string',
    isRequired: true,
},
        created_at: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
    },
};